/**
 * Gamification Helper Functions
 * Helper functions for awarding XP for various user actions
 */

import { awardXP, isTaskCompleted } from './gamification';

/**
 * Award XP for upgrading to a paid account
 * Call this when a user successfully subscribes to a paid plan
 */
export async function awardUpgradeAccountXP(userId: string): Promise<void> {
  try {
    const alreadyCompleted = await isTaskCompleted(userId, 'upgrade_account');
    if (!alreadyCompleted) {
      await awardXP(userId, 'upgrade_account', 100);
      // eslint-disable-next-line no-console
      console.log('[Gamification] Awarded 100 XP for upgrading account');
      window.dispatchEvent(new CustomEvent('gamificationUpdate'));
    }
  } catch (error) {
    console.error('[awardUpgradeAccountXP] Error:', error);
  }
}

/**
 * Award XP for inviting a friend
 * Call this when a user successfully refers a friend who signs up
 */
export async function awardInviteFriendXP(userId: string): Promise<void> {
  try {
    const alreadyCompleted = await isTaskCompleted(userId, 'invite_friend');
    if (!alreadyCompleted) {
      await awardXP(userId, 'invite_friend', 30);
      // eslint-disable-next-line no-console
      console.log('[Gamification] Awarded 30 XP for inviting a friend');
      window.dispatchEvent(new CustomEvent('gamificationUpdate'));
    }
  } catch (error) {
    console.error('[awardInviteFriendXP] Error:', error);
  }
}

/**
 * Award XP for joining Discord community
 * Call this when a user clicks the "Join Discord" button and confirms
 */
export async function awardJoinDiscordXP(userId: string): Promise<void> {
  try {
    const alreadyCompleted = await isTaskCompleted(userId, 'join_discord');
    if (!alreadyCompleted) {
      await awardXP(userId, 'join_discord', 20);
      // eslint-disable-next-line no-console
      console.log('[Gamification] Awarded 20 XP for joining Discord');
      window.dispatchEvent(new CustomEvent('gamificationUpdate'));
    }
  } catch (error) {
    console.error('[awardJoinDiscordXP] Error:', error);
  }
}

/**
 * Check if user has an active subscription and award XP if they do
 * Call this periodically or when checking user subscription status
 */
export async function checkAndAwardSubscriptionXP(userId: string, hasActiveSubscription: boolean): Promise<void> {
  if (hasActiveSubscription) {
    await awardUpgradeAccountXP(userId);
  }
}
